<div class=" h-full w-full gap-4">
    @if(loading) {
    <div class="flex-1 flex items-center justify-center">
        <div class="loader"></div>
    </div>
    } @else if(template) {
    <div class="flex flex-row h-[90%] p-[1rem]">
        <!-- Left Panel - OnlyOffice Editor -->
        <div class="flex-1 h-full overflow-hidden flex flex-col">
            <div class="flex-1 h-full w-full overflow-hidden">
                @if(config) {
                <app-only-office-doc-editor #docEditor [editorId]="'docxEditor'" [contractId]="templateLibraryId"
                    [configData]="config" [user]="currentUser!" (documentReady)="onEditorReady()">
                </app-only-office-doc-editor>
                }
            </div>

        </div>

        <!-- Right Panel - Tools Sidebar -->
        <div class="w-[25rem] bg-white border-l border-gray-200 flex flex-col h-full">
            @if(showProjectTags) {
            <!-- Project Tags UI -->
            <div class="px-4 border-gray-200">
                <app-add-project-tags [visible]="showProjectTags" (onInsert)="onProjectTagsInsert($event)"
                    (onClose)="onProjectTagsClose()">
                </app-add-project-tags>
            </div>
            } @else {
            <div class="px-4  gap-4 flex flex-col h-full">
                <div class="flex flex-row gap-4">
                    <!-- Add project tags card -->
                    <div class="border border-gray-200 rounded-2xl p-4 cursor-pointer hover:shadow-md transition-all flex flex-col gap-3 relative overflow-hidden"
                        (click)="onAddProjectTagsClick()">
                        <div class="flex items-center gap-3">
                            <div class="flex-1">
                                <h4 class="text-sm font-semibold text-gray-900">Add project tags</h4>
                                <p class="text-xs text-gray-600 mt-1">
                                    Copy and paste the tag from the list and paste it in the document.
                                </p>
                            </div>
                        </div>

                        <!-- Bottom right gradient blob -->
                        <div
                            class="absolute bottom-0 right-0 w-16 h-16 overflow-hidden rounded-br-2xl pointer-events-none">
                            <div class="absolute -bottom-4 right-1 w-10 h-10 rounded-full blur-sm"
                                style="background: var(--arena-orange-800);"></div>
                            <div
                                class="absolute bottom-1 right-1 w-6 h-6 flex items-center justify-center pointer-events-auto z-10">
                                <img src="icons/template-library/project_tags.svg" alt="Add project tags"
                                    class="w-full h-full">
                            </div>
                            <div class="absolute bottom-0 -right-2 w-10 h-10 rounded-full blur-sm"
                                style="background: #6366f1;">
                            </div>

                        </div>
                    </div>

                    <!-- Add a clause card -->
                    <div class="relative cursor-not-allowed">
                        <div class="border border-gray-200 rounded-2xl p-4 flex flex-col gap-3 opacity-50">
                            <div class="flex items-center gap-3">
                                <div class="flex-1">
                                    <h4 class="text-sm font-semibold text-gray-600">Add a clause</h4>
                                    <p class="text-xs text-gray-500 mt-1">Place the cursor where you want to insert
                                        clause
                                        and
                                        click here</p>
                                </div>
                            </div>
                        </div>
                        <!-- Coming soon overlay - outside opacity context -->
                        <div
                            class="theme-text-border absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2/3 rounded-md h-1/3 flex items-center justify-center pointer-events-none">
                            <span class="theme-text text-sm">Coming soon!</span>
                        </div>
                        <!-- Bottom right gradient blob -->
                        <div
                            class="opacity-50 absolute bottom-0 right-0 w-16 h-16 overflow-hidden rounded-br-2xl pointer-events-none">
                            <div class="absolute -bottom-2 right-1 w-10 h-10 rounded-full blur-sm"
                                style="background: var(--arena-orange-800);">
                            </div>
                            <div
                                class="absolute bottom-2 right-2 w-5 h-5 flex items-center justify-center pointer-events-auto z-10">
                                <img src="icons/template-library/clause.svg" alt="Add clause" class="w-full h-full">
                            </div>
                            <div class="absolute bottom-1 -right-2 w-10 h-10 rounded-full blur-sm"
                                style="background: #6366f1;">
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Tabs Section with orange border -->
                <div class="flex-1 flex flex-col overflow-hidden">
                    <div class=" theme-border rounded-2xl flex-1 flex flex-col overflow-hidden bg-white gap-1">
                        <!-- Custom Tab Headers -->
                        <div class="px-2 flex">
                            <div (click)="activeVersionsTab = 'versions'; onTabChange(null)"
                                class="flex items-center gap-2 py-3 px-4 cursor-pointer transition-colors"
                                [class]="activeVersionsTab === 'versions' ? 'border-b-2 border-blue-700 text-blue-700' : 'text-gray-600'">
                                <span class="font-medium">Versions</span>
                            </div>
                            <div (click)="activeVersionsTab = 'activity'; onTabChange(null)"
                                class="flex items-center gap-2 py-3 px-4 cursor-pointer transition-colors"
                                [class]="activeVersionsTab === 'activity' ? 'border-b-2 border-blue-700 text-blue-700' : 'text-gray-600'">
                                <span class="font-medium">Activity logs</span>
                            </div>
                        </div>

                        <!-- Tab Content -->
                        <div class="flex-1 overflow-hidden">
                            @if(activeVersionsTab === 'versions') {
                            <!-- Versions Tab -->
                            <div class="flex flex-col h-full px-4 pt-2">
                                <!-- Search Bar -->
                                <div>
                                    <app-search-bar placeholder="Search" [(ngModel)]="versionsSearchValue"
                                        (ngModelChange)="onVersionsSearchChange()" width="100%">
                                    </app-search-bar>
                                </div>

                                <!-- Versions List -->
                                <div class="flex-1 overflow-y-auto py-2">
                                    @if(versionLoading){
                                    <div class="space-y-2 animate-pulse">
                                        <div class="bg-gray-200 rounded-lg p-3 mb-3">
                                            <div class="h-4 bg-gray-400 w-32 rounded mb-2"></div>
                                            <div class="h-3 bg-gray-400 w-40 rounded mb-2"></div>
                                            <div class="flex gap-2 items-center">
                                                <div class="w-6 h-6 rounded-full bg-gray-400"></div>
                                                <div class="h-4 bg-gray-400 w-24 rounded"></div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    @else {
                                    @if (!versions || versions.length == 0) {
                                    <div class="flex flex-col justify-center gap-2 items-center h-full">
                                        <i [innerHTML]="TEMPLATE_LIBRARY_SVG.NO_VERSION | sanitizeHtml"
                                            style="cursor: pointer;"></i>
                                        <span class="text-gray-400">No versions yet</span>
                                    </div>
                                    }
                                    @else {
                                    <div class="space-y-1 py-2">
                                        @for (item of versions; track $index) {
                                        @if(item._id === currentVersion._id) {
                                        <div class="text-xs text-gray-600">
                                            Current version
                                        </div>
                                        }
                                        <div class="relative p-2 cursor-pointer rounded-xl"
                                            [class]="item._id === currentVersion._id ? 'bg-orange-100' : ''"
                                            [ngClass]="{'border border-arena-orange-300': item._id !== currentVersion._id && selectedVersion && selectedVersion._id === item._id}"
                                            (click)="$event.preventDefault();showVersion(item)">
                                            <div (click)="$event.stopPropagation()"
                                                class="absolute top-5 right-4 flex items-center z-10">
                                                <app-popover #menuPopover [width]="'12rem'">
                                                    <ng-template #trigger>
                                                        <div class="flex justify-start">
                                                            <i class="pi pi-ellipsis-v cursor-pointer"></i>
                                                        </div>
                                                    </ng-template>
                                                    <ng-template #body>
                                                        @for (menuItem of getMenuItems(item); track menuItem.label)
                                                        {
                                                        <div class="flex items-center py-2 px-3 cursor-pointer"
                                                            (click)="handleMenuClick(menuItem, menuPopover)">
                                                            <span [class]="menuItem.icon || ''"
                                                                [ngClass]="{'text-red-500': menuItem.label === 'Delete'}"></span>
                                                            <span class="ml-2"
                                                                [ngClass]="{'text-red-500': menuItem.label === 'Delete'}">{{
                                                                menuItem.label }}</span>
                                                        </div>
                                                        }
                                                    </ng-template>
                                                </app-popover>
                                            </div>
                                            <div class="flex items-start flex-col p-2 ">
                                                <div class="flex items-center gap-2">
                                                    <span class="text-base font-semibold text-gray-900">
                                                        {{item.name}}
                                                    </span>
                                                    <!-- small icon -->
                                                    <i class="pi pi-pencil text-gray-400 cursor-pointer hover:text-orange-500 transition-colors icon-xs"
                                                        (click)="$event.stopPropagation(); openEditVersionNameDialog(item)"
                                                        title="Edit version name"></i>
                                                </div>
                                                <div class="flex items-center justify-between w-full gap-2 mt-2">
                                                    <div class="flex items-center gap-2 text-xs text-gray-600">
                                                        @if(item === currentVersion) {
                                                        <span>{{ item.updatedAt | date: 'mediumDate' }} at {{
                                                            item.updatedAt | date: 'shortTime' }}</span>
                                                        } @else {
                                                        <span>{{ item.updatedAt | date: 'mediumDate' }}</span>
                                                        }
                                                    </div>
                                                    <div class="flex items-center gap-2">
                                                        <img [src]="item.createdBy | userAvatar" alt="User Avatar"
                                                            class="w-5 h-5 rounded-full" />
                                                        <span class="text-xs text-gray-600">{{item.createdBy |
                                                            fullName}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        @if(($index !== versions.length - 1) && ($index !== 0)) {
                                        <div class="border-b border-gray-200"></div>
                                        }
                                        }
                                    </div>
                                    }
                                    }
                                </div>
                            </div>
                            } @else if(activeVersionsTab === 'activity') {
                            <!-- Activity Logs Tab -->
                            <div class="flex flex-col h-full px-4 pt-2">
                                <!-- Search Bar -->
                                <div>
                                    <app-search-bar placeholder="Search" [(ngModel)]="activityLogsSearchValue"
                                        (ngModelChange)="onActivityLogsSearchChange()" width="100%">
                                    </app-search-bar>
                                </div>

                                <!-- Activity Logs List -->
                                <div class="flex-1 overflow-y-auto py-2">
                                    @if(activityLogsLoading){
                                    <div class="space-y-2 animate-pulse">
                                        <div class="bg-gray-200 rounded-lg p-3 mb-3">
                                            <div class="h-4 bg-gray-400 w-32 rounded mb-2"></div>
                                            <div class="h-3 bg-gray-400 w-40 rounded mb-2"></div>
                                            <div class="flex gap-2 items-center">
                                                <div class="w-6 h-6 rounded-full bg-gray-400"></div>
                                                <div class="h-4 bg-gray-400 w-24 rounded"></div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    @else {
                                    @if (!filteredActivityLogs || filteredActivityLogs.length == 0) {
                                    <div class="flex justify-center items-center h-full">
                                        <span class="text-gray-400">No activity logs available</span>
                                    </div>
                                    }
                                    @else {
                                    <div class="space-y-2 py-1">
                                        @for (log of filteredActivityLogs; track $index) {
                                        <div class="rounded-lg  mb-3 p-1">
                                            <div class="flex flex-col">
                                                <p class="text-base font-semibold text-gray-900">{{ log.description
                                                    || log.action }}</p>
                                                <div class="flex items-center justify-between gap-2">
                                                    <div class="flex items-center gap-2 text-xs text-gray-600">
                                                        <span>{{ log.createdAt | date: 'mediumDate' }}
                                                            at {{ log.createdAt | date: 'shortTime' }}
                                                        </span>
                                                    </div>
                                                    <div class="flex items-center gap-2">
                                                        <img [src]="log.createdBy | userAvatar" alt="User Avatar"
                                                            class="w-5 h-5 rounded-full" />
                                                        <app-user-name-display
                                                            [user]="log.createdBy"></app-user-name-display>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="border-b border-gray-200"></div>
                                        }
                                    </div>
                                    }
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>

    <!-- Bottom Bar -->
    <div class="flex items-center justify-between gap-2 flex-shrink-0 border-t border-gray-200 p-[1rem]">
        <!-- Warning message -->
        <div class="flex items-center gap-2">
            @if(isCurrentVersionSelected() || !selectedVersion) {
            <div class="flex items-center gap-2">
                <i class="pi pi-exclamation-triangle text-arena-orange-800"></i>
                <span class="text-xs italic">Use <span class="text-arena-orange-800 font-bold">{{ '[' }}</span> square
                    braces
                    <span class="text-arena-orange-800 font-bold">{{ ']' }}</span> to
                    mark where AI should
                    insert
                    content</span>
            </div>
            }
        </div>

        <!-- Save button -->
        <div class="flex items-center gap-2">
            <app-button variant="filled" severity="primary" label="Save" (clicked)="onSave()" [disabled]="saving || !isEditorReady"
                [loading]="saving">
            </app-button>
        </div>
    </div>
    }
</div>

<!-- Restore Version Confirmation Dialog -->
<app-dialog [(visible)]="showRestoreVersionDialog" [closable]="false" [showCloseButton]="false"
    (closed)="onCloseRestoreVersionDialog()" class="max-w-[32rem]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <hlm-dialog-header>
            <div class="flex items-start gap-3">
                <i class="pi pi-exclamation-triangle text-3xl text-orange-500 mt-2"></i>
                <div class="flex flex-col gap-1">
                    <h2 class="text-base font-semibold text-gray-900">Are you sure you want to restore this version?
                    </h2>
                    <p class="text-sm text-gray-500">This action will replace the current version with the selected one.
                    </p>
                </div>
            </div>
        </hlm-dialog-header>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel"
                (clicked)="onCloseRestoreVersionDialog()" [disabled]="restoringVersion">
            </app-button>
            <app-button variant="filled" severity="primary" label="Yes, Continue"
                (clicked)="onConfirmRestoreVersion()" [disabled]="restoringVersion" [loading]="restoringVersion">
            </app-button>
        </div>
    </ng-template>
</app-dialog>

<!-- Edit Version Name Dialog -->
<app-dialog [(visible)]="showEditVersionNameDialog" title="Edit version name"
    (closed)="onCloseEditVersionNameDialog()" class="max-w-[32rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4">
            <div class="flex flex-col gap-1.5">
                <label class="text-sm font-medium text-gray-700">
                    Version name<span class="text-red-500 ml-1">*</span>
                </label>
                <input pInputText type="text" class="w-full border rounded-base p-2 border-gray-300"
                    [(ngModel)]="editedVersionName" placeholder="Enter version name"
                    [disabled]="updatingVersionName" />
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="filled" severity="primary" label="Save" (clicked)="onConfirmEditVersionName()"
                [disabled]="updatingVersionName || !editedVersionName || editedVersionName.trim() === ''"
                [loading]="updatingVersionName">
            </app-button>
        </div>
    </ng-template>
</app-dialog>